import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tree } from 'antd';
//
import { useContentTags } from 'lib/content-tags';

function TagsTree({ tree: treeFromProps, ...restOfTheProps }) {
  const { contentTagsTree } = useContentTags();

  const displayableTree = useMemo(() => {
    return treeFromProps || contentTagsTree;
  }, [treeFromProps, contentTagsTree]);

  return <Tree blockNode treeData={displayableTree} {...restOfTheProps} />;
}

TagsTree.propTypes = {
  tree: PropTypes.array,
};

export { TagsTree };
